import { highlightParts } from '../../lib/chatSearch';

/** Message text with the searched words marked; the match being looked at stands out more. */
export function HighlightedText({ text, query, active }: { text: string; query: string; active: boolean }) {
  if (!query.trim()) return <>{text}</>;
  return (
    <>
      {highlightParts(text, query).map((part, i) => part.match ? (
        <mark
          key={i}
          style={{
            background: active ? 'var(--accent)' : 'var(--accent-border)',
            color: active ? 'var(--on-accent, #1C1B19)' : 'inherit',
            borderRadius: 3,
            padding: '0 1px',
          }}
        >
          {part.text}
        </mark>
      ) : (
        <span key={i}>{part.text}</span>
      ))}
    </>
  );
}
